module.exports = "../images/big-falls-trout-river@2x.jpg?v=a77aa14";